import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="14"
        viewBox="0 0 17 14"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(1 1)"
        >
          <path
            strokeWidth="1.333"
            d="M10.91 12v-1.333C10.91 9.194 9.687 8 8.181 8H2.727C1.221 8 0 9.194 0 10.667V12"
          />
          <ellipse cx="5.455" cy="2.667" rx="2.727" ry="2.667" />
          <path
            strokeWidth="1.333"
            d="M15 12v-1.333c0-1.216-.842-2.277-2.045-2.58M10.227.087c1.207.302 2.051 1.365 2.051 2.583 0 1.218-.844 2.281-2.05 2.583"
          />
        </g>
      </svg>
    )
  }
}

export default SvgFile



// WEBPACK FOOTER //
// ./src/Icons/ContactMembers/SvgFile.js